/* =========================================================
   BABU CHURI WALA — CART REWARDS
   Dynamic Cart Reward / Milestone Logic
   ========================================================= */

(function () {
  'use strict';

  const REWARDS_SELECTOR = '#BCW-Cart-Rewards';

  let updateTimer = null;
let lastCartValue = null;
let previousCartValue = null;


  /* =======================================================
     GET QUALIFYING CART VALUE
     ======================================================= */

  async function getCartValue() {
    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || '/'}cart.js`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          },
          cache: 'no-store'
        }
      );

      if (!response.ok) {
        throw new Error('Unable to fetch cart');
      }

      const cart = await response.json();

      /*
       * We deliberately calculate the qualifying amount from
       * individual line items instead of simply using
       * cart.total_price.
       *
       * This allows us to exclude the future automatically
       * added reward gift from the milestone calculation.
       */

      let qualifyingValue = 0;

      (cart.items || []).forEach(function (item) {
        const properties = item.properties || {};

        /*
         * Future free-gift items added by our reward system
         * will contain this property.
         */
        if (
          properties._bcw_reward_gift === 'true' ||
          properties._bcw_reward_gift === true
        ) {
          return;
        }

        qualifyingValue += Number(item.final_line_price || 0);
      });

      return qualifyingValue / 100;

    } catch (error) {
      console.warn(
        '[BCW Rewards] Could not read cart:',
        error
      );

      return null;
    }
  }


  /* =======================================================
     GET REWARD ELEMENTS
     ======================================================= */

  function getRewardElements() {
    const rewardsContainer =
      document.querySelector(REWARDS_SELECTOR);

    if (!rewardsContainer) {
      return null;
    }

    const milestones =
      rewardsContainer.querySelector(
        '[data-reward-milestones]'
      );

    if (!milestones) {
      return null;
    }

    return {
      container: rewardsContainer,
      milestones: milestones,
      rewards: Array.from(
        milestones.querySelectorAll('.bcw-cart-reward')
      )
    };
  }


  /* =======================================================
     SORT REWARDS
     ======================================================= */

  function sortRewards(rewards, milestonesContainer) {

    rewards.sort(function (a, b) {
      const thresholdA =
        Number(a.dataset.threshold || 0);

      const thresholdB =
        Number(b.dataset.threshold || 0);

      return thresholdA - thresholdB;
    });

    rewards.forEach(function (reward) {
      milestonesContainer.appendChild(reward);
    });

    milestonesContainer.style.setProperty(
      '--bcw-reward-count',
      rewards.length
    );

    return rewards;
  }


  /* =======================================================
     FORMAT RUPEE AMOUNT
     ======================================================= */

  function formatRupees(amount) {
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0
    }).format(Math.max(0, Math.ceil(amount)));
  }


  /* =======================================================
     UPDATE REWARD UI
     ======================================================= */

  async function updateRewards() {

    const elements = getRewardElements();

    if (!elements || !elements.rewards.length) {
      return;
    }

    const cartValue = await getCartValue();

    if (cartValue === null) {
      return;
    }

    /*
     * Prevent unnecessary processing if nothing changed.
     */
    if (
      lastCartValue === cartValue &&
      elements.container.dataset.initialized === 'true'
    ) {
      return;
    }

    lastCartValue = cartValue;

    const rewards = sortRewards(
      elements.rewards,
      elements.milestones
    );

    const progressElement =
      elements.container.querySelector(
        '[data-reward-progress]'
      );

    const statusElement =
      elements.container.querySelector(
        '[data-reward-status]'
      );

    const messageElement =
      elements.container.querySelector(
        '[data-reward-message]'
      );


    /* =====================================================
       DETERMINE THRESHOLDS
       ===================================================== */

    const thresholds = rewards.map(function (reward) {
      return Number(
        reward.dataset.threshold || 0
      );
    });

    const highestThreshold =
      Math.max.apply(null, thresholds);


    /* =====================================================
       UNLOCK STATES
       ===================================================== */

    let nextReward = null;

    rewards.forEach(function (reward) {

  const threshold =
    Number(reward.dataset.threshold || 0);

  const isUnlocked =
    cartValue >= threshold;

  const wasUnlocked =
    previousCartValue !== null &&
    previousCartValue >= threshold;

  const hasJustUnlocked =
    previousCartValue !== null &&
    previousCartValue < threshold &&
    cartValue >= threshold;

  reward.classList.remove('is-unlocked');
  reward.classList.remove('is-next');
  reward.classList.remove('just-unlocked');
  reward.classList.remove('is-celebrating');

  if (isUnlocked) {

    reward.classList.add('is-unlocked');

    /*
     * Trigger celebration only when the customer
     * actually crosses this milestone.
     *
     * It will NOT fire on initial cart load.
     */
    if (hasJustUnlocked && !wasUnlocked) {

      reward.classList.add('just-unlocked');
      reward.classList.add('is-celebrating');

      setTimeout(function () {
        reward.classList.remove('just-unlocked');
        reward.classList.remove('is-celebrating');
      }, 1400);

    }

  } else if (!nextReward) {

    nextReward = reward;

    reward.classList.add('is-next');

  }

});
previousCartValue = cartValue;


    /* =====================================================
       PROGRESS
       ===================================================== */

    let progress = 0;

    if (highestThreshold > 0) {
      progress =
        (cartValue / highestThreshold) * 100;
    }

    progress = Math.min(
      Math.max(progress, 0),
      100
    );

    if (progressElement) {
      requestAnimationFrame(function () {
        progressElement.style.width =
          `${progress}%`;
      });
    }


    /* =====================================================
       STATUS + MESSAGE
       ===================================================== */

    if (nextReward) {

      const nextThreshold =
        Number(
          nextReward.dataset.threshold || 0
        );

      const remaining =
        nextThreshold - cartValue;

      const rewardType =
        nextReward.dataset.rewardType;

      let rewardLabel =
        nextReward.dataset.rewardText || 'reward';

      if (rewardType === 'percentage') {

        const discount =
          Number(
            nextReward.dataset.discount || 0
          );

        rewardLabel =
          `${discount}% OFF`;

      } else if (rewardType === 'free_gift') {

        rewardLabel =
          nextReward.dataset.giftText ||
          'FREE SPECIAL GIFT';
      }


      if (statusElement) {
        statusElement.textContent =
          `Add ₹${formatRupees(remaining)} more`;
      }


      if (messageElement) {
        messageElement.textContent =
          `Unlock ${rewardLabel} at ₹${formatRupees(nextThreshold)}`;
      }

    } else {

      /*
       * Highest milestone reached.
       */

      if (statusElement) {
        statusElement.textContent =
          'All rewards unlocked';
      }

      if (messageElement) {
        messageElement.textContent =
          'You have unlocked all available rewards ✦';
      }
    }


    /* =====================================================
       MARK INITIALIZED
       ===================================================== */

    elements.container.dataset.initialized =
      'true';
  }


  /* =======================================================
     DEBOUNCED UPDATE
     ======================================================= */

  function scheduleUpdate(delay) {

    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateRewards();
    }, delay || 100);
  }


  /* =======================================================
     OBSERVE CART DRAWER
     ======================================================= */

  function observeCartDrawer() {

    const cartDrawer =
      document.querySelector('cart-drawer');

    if (!cartDrawer) {
      return;
    }

    const observer =
      new MutationObserver(function () {

        scheduleUpdate(120);

      });

    /*
     * We only watch child changes.
     *
     * We deliberately do NOT watch attributes because our
     * own class changes would otherwise create an infinite
     * update loop.
     */

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }


  /* =======================================================
     LISTEN FOR COMMON SHOPIFY CART EVENTS
     * ======================================================= */

  document.addEventListener(
    'cart:updated',
    function () {
      scheduleUpdate(100);
    }
  );

  document.addEventListener(
    'cart:refresh',
    function () {
      scheduleUpdate(100);
    }
  );


  /* =======================================================
     INITIALIZE
     ======================================================= */

  function initialize() {

    /*
     * Give Shopify a moment to finish rendering the cart
     * drawer before looking for our reward component.
     */
    setTimeout(function () {

      updateRewards();
      observeCartDrawer();

    }, 150);
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();
  }

})();
